import type { GameRuleWizardField } from "../types/gameRuleTemplate";
import { formatDisplayDate } from "../utils/displayDate";

/** Values merged into Word for Generate flow (plain text in placeholders). */
export const valueForWord = (f: GameRuleWizardField, raw: string | undefined): string => {
  const v = raw ?? "";
  if (f.type === "checkbox") {
    return v === "true" || v === "1" || v.toLowerCase() === "yes" ? "Yes" : "No";
  }
  if (f.type === "date_picker") {
    const t = v.trim();
    if (!t) return "";
    const formatted = formatDisplayDate(t);
    return formatted === "—" ? t : formatted;
  }
  return v;
};
